// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__vTa29","title":"AfterBackImages_title__3Sg0_","images":"AfterBackImages_images__1KFBe"};